export default {
  editingTextNumber: 0
}
